/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown>, date: NonNullable<unknown> }} Nda_Signed_RowInputs */



/**
* | output |
* | --- |
* | "Signed by {name} on {date}" |
*
* @param {Nda_Signed_RowInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const nda_signed_row = /** @type {((inputs: Nda_Signed_RowInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nda_Signed_RowInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Signé par ${i?.name} le ${i?.date}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Firmado por ${i?.name} el ${i?.date}`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Assinado por ${i?.name} em ${i?.date}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Firmato da ${i?.name} il ${i?.date}`)
	return /** @type {LocalizedString} */ (`Signed by ${i?.name} on ${i?.date}`)
});